<template>
  <div class="users">
    <template v-if="tableItems.length">
      <AppTable
        :fields="tableFields"
        :items="tableItems"
      >
        <template #name="data">
          <BaseLink :href="`/user/${data.id}`">
            {{ data.name }}
          </BaseLink>
        </template>
      </AppTable>
    </template>

    <p
      v-else
      class="h3"
    >
      Список пользователей пуст
    </p>
  </div>
</template>

<script>
import AppTable from '@/components/AppTable'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'Users',
  components: {
    BaseLink,
    AppTable
  },
  data () {
    return {
      tableFields: [
        { key: 'name', label: 'Имя', slot: true },
        { key: 'surname', label: 'Фамилия' },
        { key: 'username', label: 'Логин' },
        { key: 'email', label: 'Почта' },
        { key: 'createdAt', label: 'Дата создания' }
      ],
      tableItems: []
    }
  },
  async created () {
    await this.fetchUsers()
  },
  methods: {
    async fetchUsers () {
      try {
        const { data } = await this.$api.events.members(this.$route.params.id)
        const list = data?.list ?? []

        this.tableItems = list.map(item => {
          const name = item?.name ?? ''
          const surname = item?.surname ?? ''
          const username = item?.username ?? ''
          const email = item?.email ?? ''
          const createdAt = item?.createdAt ?? ''

          return {
            id: item?.id,
            name,
            surname,
            username,
            email,
            createdAt
          }
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.users {
}
</style>
